
import { Vue, Component } from 'vue-property-decorator';
import { bgKV } from '@common/config';
import biliActEvents from '@bilibili/bili-act-events'

import '@common/bideo.js';

const key = 's13-archives-open-kv-show';

@Component({
  components: {},
})
export default class KV extends Vue {
  show = true;
  // show = localStorage.getItem(key) !== '1'
  canPlay = false;
  mounted() {
    this.resizeVideo();
    if (localStorage) {
      const isKVActive = localStorage.getItem('kvActive');
      console.log('isKVActive', isKVActive);
      if (isKVActive === 'true') {
        this.show = false;
        biliActEvents.emit('ADD_WHEEL')
      } else {
        localStorage.setItem('kvActive', 'true');
      }
    }
    (window as any).navigaInterval = setInterval(() => {
      if (this.show) {
        const domNavi = document.getElementsByClassName(
            'activity-navigator'
        )[0] as HTMLDivElement;
        if (domNavi && domNavi.style) {
          domNavi.style.display = 'none';
        }
      }
    }, 100);
  }
  resizeVideo() {
    const bv = new (window as any).Bideo();
    const src = bgKV;
    // const self = this
    bv.init({
      videoEl: this.$refs.openVideo,
      container: this.$refs.kvWrapper,
      resize: true,
      autoplay: true,
      isMobile: false,
      src: [
        {
          src,
          type: 'video/mp4',
        },
      ],
      onPlay: () => {
        this.canPlay = true;
        // 首次进入才播 KV
        localStorage.setItem(key, '1');
        // setTimeout(() => {
        //   this.show = false
        // }, 2000)
        setTimeout(() => {
          clearInterval((window as any).navigaInterval);
          this.show = false;
          // biliActEvents.emit('ADD_WHEEL')
          if (document.getElementById('bgvideo')) {
            const myVideo: any = document.getElementById('bgvideo');
            myVideo.play();
            myVideo.currentTime = 0;
          }
          const domNavi = document.getElementsByClassName(
              'activity-navigator'
          )[0] as HTMLDivElement;
          domNavi.style.display = 'block';
        }, 4000);
      },
    });
  }
}
